export default __webpack_public_path__ + "static/media/gallery-wip-bunny-ears_03.2e8ae91b.jpg";